export default {
  home: '/kr',
  world: '/kr/the-worlds-of-chaumet/:param'
}



// WEBPACK FOOTER //
// ./src/locales/kr/routes.js